var map;

var BlsCreateMapStoreLocation = (function () {
  let isInitialized = false;
  let isLoadingAssets = false;
  let geocoderAdded = false;
  let resizeBound = false;

  return {
    init: function () {
      if (isInitialized) return;

      const section = document.querySelector('.bls__location-page');
      const mapElement = document.getElementById('map');

      if (!section || !mapElement) return;

      if (window.Shopify && Shopify.designMode) {
        mapElement.innerHTML =
          '<div style="padding:20px;text-align:center;background:#f5f5f5;border:1px solid #ddd;border-radius:8px;">Karte ist im Theme-Editor deaktiviert und wird nur im Live-Shop geladen.</div>';
        return;
      }

      if (typeof mapboxgl === 'undefined') return;

      if (window.storeLocatorMap) {
        try {
          window.storeLocatorMap.remove();
        } catch (e) {}
        window.storeLocatorMap = null;
      }

      const stores = document.querySelectorAll('.store-infor__items');
      if (!stores.length) return;

      const storeArray = Array.from(stores).map((element, index) => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              Number(element.dataset.lng),
              Number(element.dataset.lat)
            ]
          },
          properties: {
            id: `store_${index}`,
            index: index,
            phone: element.dataset.phone || '',
            address: element.dataset.address || '',
            name: element.dataset.name || ''
          }
        };
      });

      const listStore = {
        type: 'FeatureCollection',
        features: storeArray
      };

      mapboxgl.accessToken = 'pk.eyJ1Ijoia2hpZW1waGFtIiwiYSI6ImNsam01eHhnaTAyNmczZmxzcnQ1MTVqN3gifQ.WVqIQlSk52FSN8W7G5gsnw';

      mapElement.classList.add('is-map-active');

      map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [10.4515, 51.1657],
        zoom: 5.5,
        pitch: 0,
        bearing: 0
      });

      window.storeLocatorMap = map;
      isInitialized = true;

      map.on('load', () => {
        if (!map.getSource('places')) {
          map.addSource('places', {
            type: 'geojson',
            data: listStore
          });
        }

        const bounds = new mapboxgl.LngLatBounds();
        listStore.features.forEach((feature) => {
          bounds.extend(feature.geometry.coordinates);
        });

        if (!bounds.isEmpty()) {
          map.fitBounds(bounds, { padding: 50 });
        }

        this.addMarker(listStore);
        this.storeInforAction(listStore);

        requestAnimationFrame(() => {
          map.resize();
        });

        setTimeout(() => {
          if (window.storeLocatorMap) {
            window.storeLocatorMap.resize();
          }
        }, 250);
      });

      if (!resizeBound) {
        let resizeTimer;
        window.addEventListener('resize', function () {
          if (!window.storeLocatorMap) return;

          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            window.storeLocatorMap.resize();
          }, 200);
        });
        resizeBound = true;
      }
    },

    ensureGeocoder: function () {
      if (geocoderAdded) return;
      if (!window.storeLocatorMap) return;
      if (typeof MapboxGeocoder === 'undefined') return;

      window.storeLocatorMap.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl
        }),
        'top-left'
      );

      geocoderAdded = true;
    },

    loadAssetsAndInit: function (withGeocoder) {
      if (isInitialized) {
        if (withGeocoder) this.ensureGeocoder();
        return;
      }

      if (isLoadingAssets) return;

      const mapElement = document.getElementById('map');
      if (!mapElement) return;

      isLoadingAssets = true;
      mapElement.classList.add('is-loading');

      const cssUrls = [
        mapElement.dataset.mapboxCss,
        mapElement.dataset.mapboxGeocoderCss
      ].filter(Boolean);

      const jsUrls = [
        mapElement.dataset.mapboxJs,
        mapElement.dataset.mapboxGeocoderJs
      ].filter(Boolean);

      const loadCss = (href) => {
        return new Promise((resolve) => {
          if (document.querySelector(`link[href="${href}"]`)) {
            resolve();
            return;
          }

          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          link.onload = resolve;
          link.onerror = resolve;
          document.head.appendChild(link);
        });
      };

      const loadScript = (src) => {
        return new Promise((resolve, reject) => {
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = src;
          script.defer = true;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      };

      Promise.all(cssUrls.map(loadCss))
        .then(() => {
          return jsUrls.reduce((promise, src) => {
            return promise.then(() => loadScript(src));
          }, Promise.resolve());
        })
        .then(() => {
          mapElement.classList.remove('is-loading');
          this.init();

          if (withGeocoder) {
            const waitForMapReady = () => {
              if (window.storeLocatorMap && window.storeLocatorMap.loaded()) {
                this.ensureGeocoder();
              } else {
                setTimeout(waitForMapReady, 80);
              }
            };
            waitForMapReady();
          }
        })
        .catch((error) => {
          console.error('Mapbox assets could not be loaded:', error);
          mapElement.classList.remove('is-loading');
        })
        .finally(() => {
          isLoadingAssets = false;
        });
    },

    activateByCard: function (card) {
      const index = Number(card.dataset.storeIndex);
      if (Number.isNaN(index)) return;

      this.loadAssetsAndInit(false);

      const waitForMap = () => {
        if (window.storeLocatorMap && window.storeLocatorMap.loaded()) {
          const feature = {
            geometry: {
              coordinates: [
                Number(card.dataset.lng),
                Number(card.dataset.lat)
              ]
            },
            properties: {
              id: `store_${index}`,
              name: card.dataset.name || '',
              address: card.dataset.address || '',
              phone: card.dataset.phone || ''
            }
          };

          this.createPopupMarker(feature);
          this.zoomMarker(feature);
          this.setActiveCardById(`store_${index}`);
        } else {
          setTimeout(waitForMap, 80);
        }
      };

      waitForMap();
    },

    syncHeaderLocation: function (card) {
      const locId = card.dataset.locationId;
      const locName = card.dataset.name;
      if (!locId) return;

      localStorage.setItem('fw_location', locId);
      localStorage.setItem('selected_location', locId);
      document.cookie = 'fw_location=' + locId + ';path=/;max-age=2592000';

      const headerEl = document.getElementById('location-popup-header-id');
      if (headerEl) headerEl.textContent = locName;

      document.dispatchEvent(new CustomEvent('locationChanged', {
        detail: { locationId: locId, locationName: locName, fromWidget: true }
      }));
    },

    bindInteractions: function () {
      const section = document.querySelector('.bls__location-page');
      const mapElement = document.getElementById('map');

      if (!section || !mapElement) return;

      const activateMap = () => {
        this.loadAssetsAndInit(true);
      };

      const activateButton = mapElement.querySelector('.store-map__activate');
      if (activateButton) {
        activateButton.addEventListener('click', activateMap);
      }

      mapElement.addEventListener('click', (event) => {
        if (event.target.closest('.store-map__activate')) return;
        activateMap();
      });

      mapElement.addEventListener('touchstart', activateMap, { passive: true });

      const cards = document.querySelectorAll('.store-infor__items');
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.store-infor__link')) return;
          this.syncHeaderLocation(card);
          this.activateByCard(card);
        });
      });
    },

    addMarker: function (listStore) {
      listStore.features.forEach((store) => {
        const marker = document.createElement('div');
        marker.id = `marker-${store.properties.id}`;
        marker.classList.add('marker');

        marker.addEventListener('click', () => {
          this.createPopupMarker(store);
          this.zoomMarker(store);
          this.setActiveCardById(store.properties.id);
        });

        new mapboxgl.Marker(marker, { offset: [0, -23] })
          .setLngLat(store.geometry.coordinates)
          .addTo(map);
      });
    },

    createPopupMarker: function (store) {
      const existingPopups = document.getElementsByClassName('mapboxgl-popup');
      if (existingPopups[0]) existingPopups[0].remove();

      const { address, phone, name, id } = store.properties;

      const popup = new mapboxgl.Popup({ closeOnClick: false })
        .setLngLat(store.geometry.coordinates)
        .setHTML(`
          <div class="store-popup">
            <h3>${name}</h3>
            <div>${address}${phone ? `<br>${phone}` : ''}</div>
            <div class="store-popup__actions">
              <button type="button" class="store-popup__select" data-store-id="${id}">
                Standort auswählen
              </button>
            </div>
          </div>
        `)
        .addTo(map);

      const popupElement = popup.getElement();
      const selectButton = popupElement.querySelector('.store-popup__select');

      if (selectButton) {
        selectButton.addEventListener('click', () => {
          this.scrollToStore(id);
        });
      }

      const closeButton = document.querySelector('.bls__location-page .mapboxgl-popup-close-button');
      if (closeButton) {
        closeButton.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" fill="white" class="transition">
          <use href="#icon-close" />
        </svg>`;
      }
    },

    zoomMarker: function (store) {
      if (!map) return;

      map.flyTo({
        center: store.geometry.coordinates,
        zoom: 15
      });
    },

    setActiveCardById: function (activeId) {
      document.querySelectorAll('.store-infor__items').forEach((item, index) => {
        if (`store_${index}` === activeId) {
          item.classList.add('store-active');
        } else {
          item.classList.remove('store-active');
        }
      });
    },

    scrollToStore: function (storeId) {
      const index = storeId.replace('store_', '');
      const target = document.querySelector(`.store-infor__items[data-store-index="${index}"]`);
      if (!target) return;

      document.querySelectorAll('.store-infor__items').forEach((item) => {
        item.classList.remove('store-active');
        item.classList.remove('store-flash');
      });

      target.classList.add('store-active');

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      setTimeout(() => {
        target.classList.add('store-flash');
      }, 250);

      setTimeout(() => {
        target.classList.remove('store-flash');
      }, 1600);
    },

    storeInforAction: function (listStore) {
      const listStoresInfor = document.querySelectorAll('.store-infor__items');

      listStoresInfor.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          if (e.target.closest('.store-infor__link')) return;

          const currentFeature = listStore.features[index];
          if (!currentFeature || !window.storeLocatorMap) return;

          document.querySelectorAll('.store-infor__items').forEach((el) => {
            el.classList.remove('store-active');
          });

          item.classList.add('store-active');

          this.createPopupMarker(currentFeature);
          this.zoomMarker(currentFeature);
        });
      });
    }
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  BlsCreateMapStoreLocation.bindInteractions();
});